import { makeAutoObservable } from "mobx";
import { ICredentialsStore } from "../integration-store";
import { IBraintreeCredentialsModel } from "../../../../../models/IntegrationsTypes";

class BraintreeCredentialsStore implements ICredentialsStore {
    private _changes: IBraintreeCredentialsModel = {} as IBraintreeCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    
    public get publicKey() { return this._changes.public_key; }
    public get privateKey() { return this._changes.private_key; }
    
    setPublicKey(value: string) {
        this._changes.public_key = value;
    }
    
    setPrivateKey(value: string) {
        this._changes.private_key = value;
    }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default BraintreeCredentialsStore;